import { LayoutMain } from '@/src/layouts/LayoutMain/LayoutMain'
import { AuthRoute } from '@/src/routes/routes.components'
import { PROCUREMENT_AND_MARKETS_BASE_ROUTE, PROCUREMENT_STRATEGY_TYPES, TABS } from '@/src/utils/constants'
import { LoadPlanningPage } from '@features/procurement-and-markets/load-planning/LoadPlanning.page'
import React, { Suspense } from 'react'
import { Navigate } from 'react-router-dom'
import { LoadPlanningCurrentLocationProvider } from '../load-planning/contexts/LoadPlanningCurrentLocationContext'

const ProcurementDetailV2Lazy = React.lazy(() => import('././ProcurementDetailScreen'))
const ProcurementDetailLiveMarketLazy = React.lazy(() => import('././ProcurementDetailLiveMarket'))
const ProcurementDetailContractDetailsLazy = React.lazy(() => import('././ProcurementDetailContractDetails'))
const PortfolioDetailScreenLazy = React.lazy(() => import('../portfolio/Portfolio.screen'))
const StrategylessDetailScreenLazy = React.lazy(() => import('./ProcurementStrategylessDetail.screen'))

const DetailPageWrapper = () => {
  return <ProcurementDetailV2Lazy />
}

const DetailPageWrapperLazy = React.lazy(() =>
  Promise.resolve({
    default: DetailPageWrapper,
  })
)

const ProcurementDetailLiveMarketScreen = (
  <Suspense fallback={<div></div>}>
    <ProcurementDetailLiveMarketLazy />
  </Suspense>
)

const ProcurementDetailContractDetailsScreen = (
  <Suspense fallback={<div></div>}>
    <ProcurementDetailContractDetailsLazy />
  </Suspense>
)

const ProcurementLoadplanningScreen = (
  <Suspense fallback={<div></div>}>
    {
      <LoadPlanningCurrentLocationProvider>
        <LoadPlanningPage />
      </LoadPlanningCurrentLocationProvider>
    }
  </Suspense>
)

const PortfolioScreen = <Suspense fallback={<div></div>}>{<PortfolioDetailScreenLazy />}</Suspense>

const StrategylessDetailScreen = (
  <Suspense fallback={<div></div>}>
    <StrategylessDetailScreenLazy />
  </Suspense>
)

const tabParam = new URLSearchParams(location.search).get('type')
const defaultPath = (tabParam: string | null) => {
  switch (tabParam) {
    case PROCUREMENT_STRATEGY_TYPES.STATIC:
      return TABS.procurement.vertragsdetails
    case PROCUREMENT_STRATEGY_TYPES.HEDGED:
      return TABS.procurement.liveMarktfolge
    case PROCUREMENT_STRATEGY_TYPES.PLANNED:
      return TABS.procurement.mengenplanung
    default:
      return TABS.procurement.liveMarktfolge
  }
}

export const procurementDetailRoutes = [
  {
    path: `${PROCUREMENT_AND_MARKETS_BASE_ROUTE}/${TABS.procurementAndMarkets.procurement}/${TABS.procurement.portfolio}`,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [{ path: '', element: StrategylessDetailScreen }],
  },
  {
    path: `${PROCUREMENT_AND_MARKETS_BASE_ROUTE}/${TABS.procurementAndMarkets.procurement}/${TABS.procurement.mengenplanung}`,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [{ path: '', element: StrategylessDetailScreen }],
  },
  {
    path: `${PROCUREMENT_AND_MARKETS_BASE_ROUTE}/${TABS.procurementAndMarkets.procurement}/:setId`,
    element: (
      <AuthRoute>
        <LayoutMain />
      </AuthRoute>
    ),
    children: [
      {
        path: '',
        element: <Navigate replace to={defaultPath(tabParam)} />,
      },
      {
        path: '',
        element: (
          <Suspense fallback={<div></div>}>
            <DetailPageWrapperLazy />
          </Suspense>
        ),
        children: [
          { path: TABS.procurement.portfolio, element: PortfolioScreen },
          { path: TABS.procurement.liveMarktfolge, element: ProcurementDetailLiveMarketScreen },
          { path: TABS.procurement.vertragsdetails, element: ProcurementDetailContractDetailsScreen },
          { path: TABS.procurement.mengenplanung, element: ProcurementLoadplanningScreen },
        ],
      },
    ],
  },
]
